import store from '@/store'

export default ({ app }) => {
  app.use(store)
}
